module.exports = __webpack_public_path__ + "svg/taurus.svg?34aebadaee52cbc38aabc5e53ef3d6e6";